import { useState } from "react";
import { faqs, editorialValues } from "@/mocks/media";

export default function AboutFaq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 py-12 md:py-16 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">VALUES</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">我们的编辑立场</h2>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              吃瓜也讲分寸。51影院以"核实、尊重、克制、开放"为底色，在追逐热点的同时，始终守住内容媒体应有的底线。
            </p>
            <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {editorialValues.map((v) => (
                <div key={v.title} className="flex gap-3 p-4 rounded-lg bg-background-50 border border-background-200">
                  <span className="w-10 h-10 shrink-0 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center text-lg">
                    <i className={v.icon}></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900">{v.title}</h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">FAQ</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">常见问题</h2>
            <div className="mt-6 flex flex-col gap-3">
              {faqs.map((f, i) => (
                <div key={i} className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpen(open === i ? null : i)}
                    aria-expanded={open === i}
                    className="w-full flex items-center justify-between gap-3 px-4 py-3.5 text-left"
                  >
                    <span className="text-sm font-medium text-foreground-800 leading-snug flex-1">{f.q}</span>
                    <i className={`ri-arrow-down-s-line text-xl text-primary-600 transition-transform ${open === i ? "rotate-180" : ""}`}></i>
                  </button>
                  {open === i && (
                    <div className="px-4 pb-4 text-sm text-foreground-600 leading-relaxed">{f.a}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}